module.exports = __webpack_public_path__ + "6171c77a30f2d7c6eb05359fe424a53b.png";